import * as React from 'react';

function SvgUniversity(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 16" {...props}>
      <path
        fillRule="evenodd"
        d="M0 4.14L10.43 0l10.3 3.87-10.1 5.1-.28.15L0 4.14zm9.84 6.84l6.03-2.93v4.72s-3.23 0-6.03 3.28c-2.77-3.28-5.97-3.28-5.97-3.28V8.05l5.97 2.93z"
      />
    </svg>
  );
}

export default SvgUniversity;
